<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex mb-4>
        <h2>Join the team!</h2>
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="8" offset="2">
                <v-text-field v-model="user.email" :rules="emailRules" label="E-mail" required outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" offset="2">
                <v-alert type="info" dense>
                  Max character limit for username is 14 characters.
                </v-alert>
                <v-text-field v-model="user.username" label="Username" :rules="nameRules" required outlined maxlength="14"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" offset="2">
                <v-text-field
                  v-model="user.password"
                  label="Password"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  @click:append="show = !show"
                  required
                  outlined>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" md="4" offset-md="2">
                <v-text-field v-model="user.firstname" :rules="nameRules" label="First name" required outlined></v-text-field>
              </v-col>
              <v-col cols="8" md="4">
                <v-text-field v-model="user.lastname" :rules="nameRules" label="Last name" required outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" offset="2">
                <v-text-field v-model="user.phoneNumber" label="Phone Number" required outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" offset="2">
                <v-text-field v-model="user.connection" label="Connection to Team" required outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="8" md="4">
                <v-btn @click="createAccount(user)" color="primary" block large>Join</v-btn>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" md="4">
                <router-link :to="{ path: '/sign-in'}" replace>Go to Sign In</router-link>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import fb from 'firebase'
import db from '@/plugins/db'

export default {
  data: () => ({
    valid: true,
    show: false,
    user: {
      email: '',
      username: '',
      password: '',
      firstname: '',
      lastname: '',
      phoneNumber: '',
      connection: '',
    },
    nameRules: [
      v => !!v || 'Name is required',
    ],
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
  }),

  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    createAccount: function (user) {
      fb.auth().createUserWithEmailAndPassword(user.email, user.password).then((s) => {
        let uid = s.user.uid
        delete user.password
        user.name = user.firstname + ' ' + user.lastname
        delete user.firstname
        delete user.lastname
        user.approved = false
        user.createdAt = fb.database.ServerValue.TIMESTAMP
        db.ref(`users/${uid}`).set(user).then((s) => {
          window.location = '/support.html'
        }).catch((error) => {
          this.errorMessage = error.message
        })
      }).catch((error) => {
        if (error.code === 'permission_denied') {
          this.errorMessage = 'You do not have permission to access the desired data.'
        } else {
          this.errorMessage = error.message
        }
      })
    },
  },
}
</script>
